import { InputType } from "../../../../schemas/schema.types.js";
import { IntervalBase } from "../types.js";
import { CommonSchemaIds } from "./common.const.js";
export const COMMON_TLMD_SCHEMAS = {
    [CommonSchemaIds.VISIBLE]: {
        id: CommonSchemaIds.VISIBLE,
        schema: {
            type: 'boolean',
            default: 'true'
        },
        enum: [
            { value: false, dictionaryKey: `schema.${CommonSchemaIds.VISIBLE}.options.hidden` },
            { value: true, dictionaryKey: `schema.${CommonSchemaIds.VISIBLE}.options.visible` }
        ],
        input: {
            type: InputType.CheckField,
            properties: {
                transform: 'capitalize'
            }
        }
    },
    [CommonSchemaIds.BASE_INTERVAL]: {
        id: CommonSchemaIds.BASE_INTERVAL,
        schema: {
            type: 'string',
            default: 'auto'
        },
        enum: [
            'auto',
            { value: IntervalBase.HOURS, dictionaryKey: `temporalUnits.${IntervalBase.HOURS}.long.plural` },
            { value: IntervalBase.DAYS, dictionaryKey: `temporalUnits.${IntervalBase.DAYS}.long.plural` },
            { value: IntervalBase.WEEKS, dictionaryKey: `temporalUnits.${IntervalBase.WEEKS}.long.plural` },
            { value: IntervalBase.MONTHS, dictionaryKey: `temporalUnits.${IntervalBase.MONTHS}.long.plural` },
            { value: IntervalBase.YEARS, dictionaryKey: `temporalUnits.${IntervalBase.YEARS}.long.plural` }
        ],
        input: {
            type: InputType.SelectField,
            properties: {
                transform: 'capitalize'
            }
        }
    },
    [CommonSchemaIds.INTERVAL]: {
        id: CommonSchemaIds.INTERVAL,
        schema: {
            type: 'object',
            unevaluatedProperties: false,
            properties: {
                value: {
                    type: 'number',
                    default: 1
                },
                unit: {
                    type: 'string',
                    default: 'auto',
                    enum: [
                        'auto',
                        IntervalBase.HOURS,
                        IntervalBase.DAYS,
                        IntervalBase.WEEKS,
                        IntervalBase.MONTHS,
                        IntervalBase.YEARS
                    ]
                }
            },
            required: ['value', 'unit']
        },
        enum: [
            'auto',
            { value: IntervalBase.HOURS, dictionaryKey: `temporalUnits.${IntervalBase.HOURS}.long.plural` },
            { value: IntervalBase.DAYS, dictionaryKey: `temporalUnits.${IntervalBase.DAYS}.long.plural` },
            { value: IntervalBase.WEEKS, dictionaryKey: `temporalUnits.${IntervalBase.WEEKS}.long.plural` },
            { value: IntervalBase.MONTHS, dictionaryKey: `temporalUnits.${IntervalBase.MONTHS}.long.plural` },
            { value: IntervalBase.YEARS, dictionaryKey: `temporalUnits.${IntervalBase.YEARS}.long.plural` }
        ],
        input: {
            type: InputType.PhysicalPropertyField,
            properties: {
                transform: 'capitalize'
            }
        }
    }
};
/**
 * The double enum does not feel right. Also multiple enums does not work.
 * maybe:
    [CommonSchemaIds.INTERVAL]: {
        id: CommonSchemaIds.INTERVAL,
        schema: {
            type: 'object',
            unevaluatedProperties: false,
            properties: {
                value: {
                    type: 'number',
                    default: 1
                },
                unit: {
                    type: 'string',
                    default: 'auto',
                }
            },
            required: ['value', 'unit']
        },
        enum:{
            unit:[
                'auto',
                { value: IntervalBase.HOURS, dictionaryKey: `temporalUnits.${IntervalBase.HOURS}.long.plural` },
                { value: IntervalBase.DAYS, dictionaryKey: `temporalUnits.${IntervalBase.DAYS}.long.plural` },
                { value: IntervalBase.WEEKS, dictionaryKey: `temporalUnits.${IntervalBase.WEEKS}.long.plural` },
                { value: IntervalBase.MONTHS, dictionaryKey: `temporalUnits.${IntervalBase.MONTHS}.long.plural` },
                { value: IntervalBase.YEARS, dictionaryKey: `temporalUnits.${IntervalBase.YEARS}.long.plural` }
            ]
        },
        input: {
            type: InputType.PhysicalPropertyField,
            properties: {
                transform: 'capitalize'
            }
        }
    }
 *

    and inject every enum in it's assigned property (after proper translations.) Should occur in schema.ts:l39 getJSONSchema in tlmd-data
    the schema.type should be checked for === 'object'
 */ 
